import http from "./api";

//项目名称模糊查询
export const getProjectList = data => {
  return http({
    url: "/complaint/interface/findProjectName",
    method: "post",
    data
  });
};
export const getCheckCode = data => {
  return http({
    url: "/provinceComplaint/interface/getCaptcha",
    method: "post",
    responseType: "blob",
    isFile: true,
    notDownload: true,
    data
  });
};
//发送短信验证码
export const registerYzm = data => {
  return http({
    url: "/provinceComplaint/interface/sendSms",
    method: "post",
    data
  });
};

//区市
export const getArea = data => {
  return http({
    url: "/provinceComplaint/interface/getAreaList",
    method: "post",
    data
  });
};

// 电话簿
export const findRegionalContactsList = data => {
  return http({
    url: "/provinceComplaint/interface/findRegionalContactsList",
    method: "post",
    data
  });
};

//行业主管列表
export const getIndustry = () => {
  return http({
    url: "/complaint/interface/getIndustry",
    method: "post"
  });
};
//提交
export const submit = data => {
  return http({
    url: "/provinceComplaint/interface/add",
    method: "post",
    data
  });
};

//获取图形验证码数据
export const captchaImage = () => {
  return http({
    url: "/provinceComplaint/interface/getProvComplaintCaptchaImage",
    method: "post",
  });
}
//滑块验证码校验接口
export const checkCaptcha = data => {
  return http({
    url: "/provinceComplaint/interface/checkProvComplaintCaptchaAndSendSms",
    method: "post",
    data
  });
}

//滑块验证码校验接口
export const getSm2Key = data => {
  return http({
    url: "/api/getSm2Key",
    method: "post",
    data
  });
}

export default {
  getProjectList,
  registerYzm,
  getArea,
  getIndustry,
  submit,
  getCheckCode,
  findRegionalContactsList,
  captchaImage,
  checkCaptcha,
  getSm2Key
};
